<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <div class="place_order_title">填写并核对订单信息</div>
            <div class="place_order_root">
                <div style="overflow: hidden">
                    <div class="receiving_info_bor"></div>
                    <div class="receiving_info_txt">收货信息</div>
                </div>

                <div class="address_item" :style="{ background: address_list_index === a ? '#f4f4f4' : '#fff' }" v-if="address_list" v-for="(item, a) in address_list" @click="chang_address_list(a)">
                    <div style="width: 55%; float: left; height: 100%; overflow: hidden">
                        <div class="address_item_1" style="position: relative; background: #fff">
                            <img v-if="address_list_index === a" src="../assets/dizhi_moren.png" style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" alt="" />
                            {{ item.userName }}
                        </div>
                        <div class="address_item_2">
                            {{ item.province + '/' + item.city + '/' + item.area + '/' + item.detailAddress }}
                        </div>
                        <div class="address_item_2">{{ item.userNum }}</div>
                        <div class="address_item_3" v-if="item.defaultAddress === 1">
                            默认地址
                        </div>
                    </div>
                    <div style="float: right; overflow: hidden; width: 20%">
                        <div class="address_item_4" style="padding-right: 20px" @click="deleteAddress(item)">
                            删除
                        </div>
                        <div class="address_item_4" style="margin-right: 20px" @click="editAddress(item)">
                            编辑
                        </div>
                        <div @click="morendizhi(item)" class="address_item_4" style="margin-right: 20px; color: #2b9a34">
                            {{ item.defaultAddress === 0 ? '设为默认地址' : '取消默认地址' }}
                        </div>
                    </div>
                </div>

                <div class="add_address_txt" @click.stop="ShowHidden = !ShowHidden">+新增收货地址</div>
                <div style="width: 100%;border: 1px solid #ede9e9;margin-top: 2%;overflow: hidden;padding-bottom: 2%;" v-if="ShowHidden">
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red">*</span>收货人</div>
                        <a-input v-model="obj.userName" style="width: 365px; float: left; margin-left: 10px" placeholder="收货人" />
                    </div>
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red">*</span>收货地址</div>
                        <div style="overflow: hidden">
                            <a-select :value="obj.province ? obj.province : '请选择省'" @change="sheng_Change" style="width: 120px; margin-left: 1%">
                                <a-select-option :key="b" v-for="(item, b) in all_available" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>

                            <a-select :value="obj.city ? obj.city : '请选择市'" default-value="请选择市" @change="shi_Change" style="width: 120px">
                                <a-select-option :key="c" v-for="(item, c) in all_shi" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>

                            <a-select :value="obj.area ? obj.area : '请选择区'" default-value="请选择区" @change="qu_Change" style="width: 120px">
                                <a-select-option :key="d" v-for="(item, d) in all_qu" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                            <a-select v-if="sanhuan_show" default-value="请选择三环内/三环外" @change="qu1_Change">
                                <a-select-option value="INNER">
                                    三环内
                                </a-select-option>
                                <a-select-option value="OUTER">
                                    三环外
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red">*</span>详细地址</div>
                        <a-input style="width: 365px; float: left; margin-left: 10px" v-model="obj.detailAddress" placeholder="请输入详细地址" />
                    </div>
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red">*</span>手机号码</div>
                        <a-input style="width: 365px; float: left; margin-left: 10px" v-model="obj.userNum" placeholder="请输入手机号码" />
                    </div>
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red"></span>固定电话</div>
                        <a-input style="width: 110px; float: left; margin-left: 10px" v-model="obj.areaCode" placeholder="区号" />
                        <a-input style="width: 110px; float: left; margin-left: 10px" v-model="obj.landlineNum" placeholder="座机号" />
                        <a-input style="width: 110px; float: left; margin-left: 10px" v-model="obj.extNum" placeholder="座机分号" />
                    </div>
                    <div style="width: 100%; overflow: hidden; margin-top: 2%">
                        <div class="add_address_form"><span style="color: red"></span>电子邮件</div>
                        <a-input style="width: 365px; float: left; margin-left: 10px" v-model="obj.email" placeholder="请输入电子邮箱" />
                    </div>
                    <a-checkbox @change="defaultAddress_onChange" v-model="obj.defaultAddress" style="margin-left: 120px; margin-top: 1%">
                        设为默认
                    </a-checkbox>
                    <div style="overflow: hidden;width: 20%;margin-left: 120px;margin-top: 1%;">
                        <div class="submit_but" @click="add_address_but">确认收货地址</div>
                        <div style="float: left;font-size: 14px; color: #333333; margin-left: 20px;line-height: 40px;">
                            取消
                        </div>
                    </div>
                </div>

                <div style="width: 100%;height: 1px;border: 1px solid #ede9e9;margin-top: 4%;"></div>
                <div style="overflow: hidden; margin-top: 4%">
                    <div class="receiving_info_bor"></div>
                    <div class="receiving_info_txt">商品信息</div>
                </div>

                <div v-for="(item, y) in cart_goods_list" :key="y">
                    <div>
                        <div style="overflow: hidden; margin-top: 2%">
                            <div class="ziying">
                                {{ item.storeInfo.type === 'SELF' ? '自营' : '普通' }}
                            </div>
                            <div class="shop_name">商家：{{ item.storeInfo.name }}</div>
                        </div>
                        <div class="goods_list">
                            <div class="goods_list_item">商品图</div>
                            <div class="goods_list_item">产品名称</div>
                            <div class="goods_list_item">品牌|货号</div>
                            <div class="goods_list_item">规格</div>
                            <div class="goods_list_item">包装</div>
                            <div class="goods_list_item">交期</div>
                            <div class="goods_list_item">数量</div>
                            <div class="goods_list_item">单价</div>
                            <div class="goods_list_item">小计</div>
                        </div>
                        <div class="goods_list" style="background: #f4f4f4; height: 70px; margin-top: 0">
                            <div class="goods_list_item tiao" style="line-height: 70px; font-size: 14px" @click="tiao(_item, index)">
                                <img :src="`/api/file/preview/${cart_goods_list[0].active_list[0].cover}`" alt="" style="width:50%" />
                            </div>
                            <div class="goods_list_item" style="line-height: 70px; font-size: 14px">
                                <div style="overflow: hidden; white-space: nowrap;text-overflow: ellipsis;width: 80%;margin: auto;" @click="tiao(item, index)" class="tiao">
                                    {{ cart_goods_list[0].active_list[0].name }}
                                </div>
                            </div>
                            <div class="goods_list_item">
                                <p style="line-height: 20px;margin-top: 20px;margin-bottom: 0;color: #2b9a34;">
                                    {{ cart_goods_list[0].active_list[0].skuList.brandName }}
                                </p>
                                <p style="line-height: 20px">
                                    {{ cart_goods_list[0].active_list[0].skuList.skuSn }}
                                </p>
                            </div>
                            <div class="goods_list_item" style="line-height: 70px">
                                {{ cart_goods_list[0].active_list[0].skuList.specification }}
                            </div>
                            <div class="goods_list_item" style="line-height: 70px">
                                {{ cart_goods_list[0].active_list[0].skuList.packaging }}
                            </div>
                            <div class="goods_list_item" style="line-height: 70px; color: #2b9a34">
                                {{ cart_goods_list[0].active_list[0].skuList.deliveryTime }}
                            </div>

                            <div class="goods_list_item">
                                <p style="line-height: 20px; margin-top: 20px; margin-bottom: 0">
                                    {{ sku.quantity }}
                                </p>
                                <p style="line-height: 20px">
                                    {{ sku.stock > 0 || _item.stock == null ? '有货' : '无货' }}
                                </p>
                            </div>

                            <div class="goods_list_item" style="line-height: 70px">
                                {{ sku.price | moneyStr }}
                            </div>

                            <div class="goods_list_item">
                                <p style="line-height: 20px;margin-top: 20px;margin-bottom: 0;color: #f24145;font-weight: bold;">
                                    {{ sku.price_total | moneyStr }}
                                </p>
                                <p v-if="sku.price_discount" style="line-height: 20px">节省: {{ sku.price_discount | moneyStr }}</p>
                            </div>
                            <div v-if="item.active_list[0].riskNature === '易制毒化学品'" class="goods_list_item bianju">
                                <button class="zhidu" @click="zhengjiandu = true">上传证件</button>
                            </div>
                            <div v-if="item.active_list[0].riskNature === '易制爆化学品'" class="goods_list_item bianju">
                                <button class="zhidu" @click="zhengjianbao = true">上传证件</button>
                            </div>
                        </div>
                        <a-modal v-model="zhengjiandu" title="上传易制毒化学品证件" :footer="null">
                            <div>
                                <a-button @click="(yingyongzhidu = true), (zhengjiandu = false)" type="primary" ghost size="large" style="margin-left:60px">引用证件</a-button>
                                <a-button type="primary" size="large" style="margin-left:140px" @click="(xzzhidu = true), (zhengjiandu = fasle)">新增证件</a-button>
                            </div>
                            <p style="margin-top:30px">1、若之前上传过证件且在有效期内，可点击引用证件</p>
                            <p>2、新增证件：</p>
                            <p>购买易制爆产品</p>
                            <p>经销商请上传：</p>
                            <p>2.1截图（人员+场所）</p>
                            <p>2.2易制爆危险化学品从业单位备案证明</p>
                            <p>2.3危化品经营许可证</p>
                            <p>终端请上传</p>
                            <p>2.4截图（人员+场所）</p>
                            <p>2.5易制爆危险化学品从业单位备案证明</p>
                            <p>2.6提供合法使用说明（鲜章）</p>
                            <p>2.7经办人身份证（正反面）</p>
                        </a-modal>
                        <!-- 新增易制毒 -->
                        <a-modal v-model="xzzhidu" title="新增易制毒证件" width="1020px" :footer="null">
                            <xyizhi-du></xyizhi-du>
                        </a-modal>
                        <!-- 引用易制毒 -->
                        <a-modal v-model="yingyongzhidu" title="引用易制毒证件" width="1020px" :footer="null">
                            <yizhi-du></yizhi-du>
                        </a-modal>

                        <a-modal v-model="zhengjianbao" title="上传易制爆化学品证件" :footer="null">
                            <div>
                                <a-button type="primary" ghost size="large" style="margin-left:60px" @click="(visible11 = true), (zhengjianbao = false)">引用证件</a-button>
                                <a-button type="primary" size="large" style="margin-left:140px" @click="(visible22 = true), (zhengjianbao = false)">新增证件</a-button>
                            </div>
                            <p style="margin-top:30px">1、若之前上传过证件且在有效期内，可点击引用证件</p>
                            <p>2、新增证件：</p>
                            <p>购买易制爆产品</p>
                            <p>经销商请上传：</p>
                            <p>2.1截图（人员+场所）</p>
                            <p>2.2易制爆危险化学品从业单位备案证明</p>
                            <p>2.3危化品经营许可证</p>
                            <p>终端请上传</p>
                            <p>2.4截图（人员+场所）</p>
                            <p>2.5易制爆危险化学品从业单位备案证明</p>
                            <p>2.6提供合法使用说明（鲜章）</p>
                            <p>2.7经办人身份证（正反面）</p>
                        </a-modal>
                        <!-- 引用易制爆 -->
                        <a-modal v-model="visible11" title="引用易制爆证件" width="1020px" :footer="null">
                            <yizhi-bao />
                        </a-modal>
                        <!-- 新增易制爆 -->
                        <a-modal v-model="visible22" title="新增易制爆证件" width="1020px" :footer="null">
                            <xyizhi-bao></xyizhi-bao>
                        </a-modal>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div style="width: 35%; float: left">
                            <div class="order_beizhu">订单备注</div>
                            <a-textarea v-model="memo" style="margin-left: 2%; float: left; width: 300px" placeholder="输入订单备注..."></a-textarea>
                        </div>
                        <div style="width: 65%; float: left">
                            <div style="overflow: hidden">
                                <div class="jifen_txt2" @click="jifenguize_visible = true">
                                    [ 了解积分兑换规则 ]
                                </div>
                                <div class="jifen_txt">
                                    <span style="float: left">积分抵用：</span>
                                    <div style="color: #666; float: left">
                                        <span style="float: left; margin-right: 20px">账户共 {{ pointMy.pointBalance }} 积分，本次使用 </span>
                                        <div style="float: left;margin-right: 30px;">
                                            <a-input-number size="small" :min="0" :max="usingPointMax" :disabled="pointRuleConfig.maxPercentPerOrder === 0 ? true : false" @change="jifenshuru" v-model="usingPoint" style="float: left;margin-left: 10px;" :placeholder="pointRuleConfig.maxPercentPerOrder === 0 ? '不能使用积分' : '请输入积分'" />
                                        </div>
                                        <span style="float: left">
                                            抵扣
                                            <span style="color: #f24145">￥{{ usingPointPre }}</span>
                                            元
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="jifen_txt" style="float: left; margin-left: 177px; margin-top: 20px;clear: both;">
                                <span style="float: left; margin-top: 10px">促销：</span>
                                <span style="color: #666">
                                    <span style="float: left; margin-top: 10px">本次商品满足优惠</span>
                                    <select v-model="promotion_id" :disabled="!listPromotionLength" style="width: 120px; margin-left: 1em;margin-top: 10px;">
                                        <option value="">{{ listPromotionLength ? '请选择优惠' : '没有可用的优惠' }}</option>
                                        <option v-for="(i, index) in list_promotion" :key="index" :value="i.uuid">{{ i.name }}</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="overflow: hidden">
                <div style="overflow: hidden; margin-top: 2%; float: right; width: 25%">
                    <div style="overflow: hidden;">
                        <div style="width: 40%;float: left;">
                            <div class="price_txt1" style="text-align: right;width: 100%;">商品数量：</div>
                        </div>
                        <div style="width: 60%;float: right;">
                            <div class="price_txt1" style="float: right;text-align: left;width: 100%;">
                                <span style="color: #f24145">{{ goods_all_count }}</span
                                >件
                            </div>
                        </div>
                    </div>
                    <div style="overflow: hidden;">
                        <div style="width: 40%;float: left;">
                            <div class="price_txt1" style="text-align: right;width: 100%;">商品金额：</div>
                        </div>
                        <div style="width: 60%;float: right;">
                            <div class="price_txt1" style="float: right;text-align: left;width: 100%;">{{ _zongjia | moneyStr }}</div>
                        </div>
                    </div>
                    <div style="overflow: hidden;">
                        <div style="width: 40%;float: left;">
                            <div class="price_txt1" style="text-align: right;width: 100%;">运费：</div>
                        </div>
                        <div style="width: 60%;float: right;">
                            <div class="price_txt1" style="float: right;text-align: left;width: 100%;">{{ price_delivery | moneyStr }}</div>
                        </div>
                    </div>
                    <div style="overflow: hidden;">
                        <div style="width: 40%;float: left;">
                            <div class="price_txt1" style="text-align: right;width: 100%;">积分抵用：</div>
                        </div>
                        <div style="width: 60%;float: right;">
                            <div class="price_txt1" style="float: right;text-align: left;width: 100%;">
                                <span>￥{{ usingPointPre }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="overflow: hidden;">
                        <div style="width: 40%;float: left;">
                            <div class="price_txt1" style="text-align: right;width: 100%;">店铺优惠：</div>
                        </div>
                        <div style="width: 60%;float: right;">
                            <div class="price_txt1" style="float: right;text-align: left;width: 100%;">{{ price_promotion | moneyStr }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="width: 100%; height: 90px; background: #f4f4f4; margin-top: 2%">
                <div style="overflow: hidden">
                    <div class="actual_price_num">{{ pricePay | moneyStr }}</div>
                    <div class="actual_price">应付金额</div>
                </div>
                <div style="overflow: hidden">
                    <div class="details_address">寄送至：{{ address_list.length > 0 ? address_list[address_list_index].province + '/' + address_list[address_list_index].city + '/' + address_list[address_list_index].area + '/' + address_list[address_list_index].detailAddress + '/' + address_list[address_list_index].userName : '' }}</div>
                </div>
            </div>
            <div style="overflow: hidden; padding-bottom: 4%">
                <div class="sub_but" @click="add_order">提交</div>
            </div>
        </div>

        <foot />

        <a-modal centered @cancel="jifenguize_visible = false" :visible="jifenguize_visible" :footer="null" :width="480" :height="240">
            <div class="pop_title">积分规则</div>
            <p style="margin-top: 20px">{{ pointRuleConfig.descriptions }}</p>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import XyizhiBao from './ImgUpload/XyizhiBao';
import ImgUpload from './ImgUpload/ImgUpload';
import YizhiBao from './ImgUpload/YizhiBao';
import XyizhiDu from './ImgUpload/XyizhiDu';
import YizhiDu from './ImgUpload/YizhiDu';
export default {
    name: 'DirectPlaceOrder',
    components: {
        userLeft,
        htmlHeader,
        foot,
        ImgUpload,
        XyizhiBao,
        YizhiBao,
        XyizhiDu,
        YizhiDu
    },
    data() {
        return {
            yingyongzhidu: false,
            zhengjiandu: false,
            visible11: false,
            xzzhidu: false,
            zhengjianbao: false,
            visible22: false,
            ShowHidden: false,
            sanhuan_show: false, //是否显示三环
            memo: '', //备注
            usingPoint: 0, //积分
            usingPointMax: 0,
            jifenguize_visible: false,
            memo: '', //订单备注
            order_obj: {
                usingPoint: null, //使用多少积分
                promotionId: null, //促销ID
                productSkuIdList: [] //商品 ID 集合
            }, //创建订单的信息
            shanchu_id: null, // 待删除地址id
            all_shi: '', // 下级市
            all_qu: '', // 下级区
            all_qu2: '', // 三环内
            all_available: '', // 所有省份
            visible: false, // 删除弹框
            cart_goods_list: [], //购物车信息,
            address_list: [], //地址列表
            address_list_index: null, //选中的地址
            obj: {
                areaId: '',
                // ring: '',
                area: '', //区
                areaCode: '', //区号
                city: '', //市
                defaultAddress: false, //默认地址 1为默认0为非默认
                detailAddress: '', //详细地址
                email: '', //电子邮箱
                extNum: '', //座分机号
                landlineNum: '', //座机号
                province: '', //省
                userId: localStorage.username, //用户uuid
                userName: '', //用户名
                userNum: '', //用户电话
                uuid: null //编辑ID
            }, // 提交地址数据
            pointMy: '', //我的积分
            pointRuleConfig: '', //积分配置规则
            zongjia: 0, //底部总价
            goods_all_count: 0, // 底部选中的商品数量
            cuxiao_list: [], //请求促销所需要的 ID
            zongdikoujifen: 0, //积分总共抵扣了多少钱
            _jifenshuru_index: 0, //当前在输入那个积分的缩影
            _zongjia: 0, //计算用
            is_show: false,
            price_delivery: 0,
            price_promotion: 0,
            sku: {},
            list_promotion: [],
            promotion_id: ''
        };
    },
    computed: {
        usingPointPre() {
            return this._numFiterFun(this.usingPoint / 100);
        },
        pointMax() {
            return Math.floor(this.pointMy.pointBalance / this.pointRuleConfig.oneFenNeedPoint / 100);
        },
        pricePay() {
            //        总价      +      运费           -  店铺优惠            -    使用积分
            return this.zongjia + this.price_delivery - this.price_promotion - this.usingPoint;
        },
        listPromotionLength() {
            return !!this.list_promotion.length;
        }
    },
    watch: {
        address_list_index() {
            this.calculateFreight();
        },
        promotion_id(value) {
            if (value) {
                const item = this.list_promotion.find(i => i.uuid === value);
                if (this.sku.price_total >= item.conditionsAmount) {
                    this.price_promotion = item.creditAmount;
                }
            } else {
                this.price_promotion = 0;
            }
        }
    },
    filters: {
        numFilter(value) {
            let realVal = '';
            if (!isNaN(value) && value !== '') {
                // 截取当前数据到小数点后两位
                realVal = parseFloat(value).toFixed(2);
            } else {
                realVal = '--';
            }
            return realVal;
        },
        moneyStr(value) {
            value = value ? value / 100 : 0;
            return '￥' + value.toFixed(2);
        }
    },
    methods: {
        // 获取易制毒证书
        getDrugMaking() {
            this.api.getmyPage().then(res => {
                console.log(res);
            });
        },
        tiao(e) {
            console.log(e.active_list[0].uuid);
            this.$router.push('/goods_details?uuid=' + e.active_list[0].uuid);
        },
        // 查询促销
        getPromotion() {
            this.api.get_cart_cuxiao({ list: [this.cart_goods_list[0].active_list[0].uuid] }).then(res => {
                console.log(res, '111');
                if (res.data && res.data[0] && res.data[0].promotionList) {
                    const list = res.data[0].promotionList;
                    this.list_promotion.push(...list);
                }
            });
        },
        // 计算运费
        calculateFreight() {
            const data = {
                addressId: '',
                memo: '',
                skuId: this.sku.uuid,
                quantity: this.sku.quantity,
                //"promotionId": "",
                usingPoint: 0
            };
            data.addressId = this.address_list[this.address_list_index].uuid;

            this.api.calculateBuy(data).then(res => {
                if (res.data) {
                    this.price_delivery = res.data.freight;
                    console.log(res.data, '请求到的优惠');
                    this.list_promotion = res.data.listPromotion;
                }
            });
        },
        res() {
            this.is_show = false;
            this.$router.push('/qualifications');
        },
        _numFiterFun(value) {
            let realVal = '';
            if (!isNaN(value) && value !== '') {
                // 截取当前数据到小数点后两位
                realVal = parseFloat(value).toFixed(2);
            } else {
                realVal = '--';
            }
            return realVal;
        },
        qu1_Change(e) {
            if (e === '三环内') {
                this.obj.ring = 'INNER';
            } else {
                this.obj.ring = 'OUTER';
            }
        },
        // 获取促销
        get_cart_cuxiao() {
            this.api
                .get_cart_cuxiao({
                    list: [this.cart_goods_list[0].active_list[0].uuid]
                })
                .then(res => {
                    res.data.forEach((element, index) => {
                        this.cart_goods_list[index].promotionList = element.promotionList;
                    });
                });
        },
        // 创建订单
        add_order() {
            if (this.address_list.length === 0) {
                this.$message.error('请添加收货地址');
                return false;
            }

            let weiguijifen = 0;
            this.cart_goods_list.forEach(element => {
                // 是否有违规的输入积分
                let _shurujifen = parseFloat(element.usingPoint);
                if (_shurujifen / this.pointRuleConfig.oneFenNeedPoint > element.shop_all_price * (this.pointRuleConfig.maxPercentPerOrder / 100)) {
                    // 如果输入超了
                    weiguijifen++;
                }
            });

            if (weiguijifen != 0) {
                this.$message.error('输入积分错误');
                return false;
            }

            // 商品数据
            let _obj = {
                memo: this.memo,
                quantity: this.cart_goods_list[0].quantity,
                skuId: this.cart_goods_list[0].active_list[0].skuList.uuid,
                promotionId: this.promotion_id || null,
                usingPoint: this.usingPoint
            };

            // 地址数据
            let dizhi = this.address_list[this.address_list_index];
            _obj.addressId = this.address_list[this.address_list_index].uuid;
            // _obj.receiverBean = {
            //   address:
            //     dizhi.province +
            //     "/" +
            //     dizhi.city +
            //     "/" +
            //     dizhi.area +
            //     dizhi.detailAddress, //详细地址
            //   areaCode: dizhi.areaCode,
            //   city: dizhi.city,
            //   cityRegion: dizhi.ring, //三环地址
            //   consignee: dizhi.userName, //收货人
            //   county: dizhi.county, //县地区名称
            //   email: dizhi.email,
            //   festnetznummer: dizhi.landlineNum, //座机
            //   festnetznummer2: dizhi.extNum, //座机分号
            //   phone: dizhi.userNum, //手机号码
            //   province: dizhi.province,
            //   // zipCode: '', //邮编
            // };
            // 请求接口
            this.api.cart_add_buy_order(_obj).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                    // 保存订单信息
                    localStorage.orderSn = res.data.orderSn;
                    localStorage.orderAmount = res.data.orderAmount;
                    localStorage.dizhi = this.address_list[this.address_list_index].userName + '/' + this.address_list[this.address_list_index].userName + '/' + this.address_list[this.address_list_index].province + '/' + this.address_list[this.address_list_index].city + '/' + this.address_list[this.address_list_index].area + '/' + this.address_list[this.address_list_index].detailAddress;

                    this.$router.push('/credit_pay?uuid=' + res.data.uuid);
                } else {
                    this.is_show = true;
                    this.$message.error(res.message);
                }
            });
        },
        // 积分输入监听
        jifenshuru() {
            this.usingPoint = Math.floor(this.usingPoint);
            if (this.usingPoint > this.usingPointMax) {
                this.usingPoint = this.usingPointMax;
            }
            // this.zongjia = this._zongjia;
            let _shurujifen = this.usingPointPre;
            if (_shurujifen / this.pointRuleConfig.oneFenNeedPoint > this.cart_goods_list[0].shop_all_price * (this.pointRuleConfig.maxPercentPerOrder / 100)) {
                // 如果输入超了
                this.$message.error('积分输入有误');
            }

            // if (this.zongjia - this.usingPointPre < 0) {
            //     return false;
            // }
            // this.zongjia = this.zongjia - this.usingPointPre;
        },
        // 积分配置获取
        get_pointRuleConfig() {
            this.api.get_pointRuleConfig().then(res => {
                const point = (this.usingPointMax * res.data.maxPercentPerOrder) / 100;
                this.usingPointMax = point < 1 ? 0 : point;

                this.pointRuleConfig = res.data;
                this.cart_goods_list[0].jifen_max = this.zongjia * (this.pointRuleConfig.maxPercentPerOrder / 100);
                // this.cart_goods_list.forEach((element) => {
                //   // 计算每个商户最多能用多少积分
                //   element.jifen_max =
                //     element.shop_all_price *
                //     (this.pointRuleConfig.maxPercentPerOrder / 100)
                // });
            });
        },
        // 获取我的积分余额
        get_pointMy() {
            this.api.get_pointMy().then(res => {
                this.pointMy = res.data;
            });
        },
        // 删除地址
        deleteAddress(e) {
            const that = this;
            that.$confirm({
                title: `是否删除该地址?`,
                onOk() {
                    that.api.deleteAddress(e.uuid).then(res => {
                        if (res.ok) {
                            that.get_my_address();
                            that.$message.success(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 切换默认地址
        morendizhi(e) {
            const that = this;
            that.$confirm({
                title: `是否${e.defaultAddress === 0 ? '设置为' : '取消'}默认地址`,
                onOk() {
                    if (e.defaultAddress === 0) {
                        that.api.defaultAddress(e.uuid).then(res => {
                            if (res.ok) {
                                that.get_my_address();
                                that.$message.success(res.message);
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                    } else {
                        that.api.cancelAddress(e.uuid).then(res => {
                            if (res.ok) {
                                that.get_my_address();
                                that.$message.success(res.message);
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                    }
                }
            });
        },
        // 切换默认地址
        defaultAddress_onChange() {
            this.obj.defaultAddress = !this.obj.defaultAddress;
        },
        // 提交地址数据
        add_address_but() {
            if (this.obj.area === '' || this.obj.city === '' || this.obj.detailAddress === '' || this.obj.province === '' || this.obj.userName === '' || this.obj.userNum === '') {
                this.$message.error('请填写完整收货信息');
            } else if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.obj.userNum)) {
                this.$message.error('请输入正确的手机号');
            } else {
                this.obj.defaultAddress = this.obj.defaultAddress ? 1 : 0;
                this.api.createOrUpdate(this.obj).then(res => {
                    if (res.ok) {
                        this.get_my_address();
                        this.$message.success('操作成功');
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        // 点击编辑地址
        editAddress(e) {
            this.obj = e;
            this.all_available.forEach(element => {
                if (element.name === e.province) {
                    this.all_shi = element.children;
                }
            });
            this.all_shi.forEach(element => {
                if (element.name === e.city) {
                    this.all_qu = element.children;
                }
            });
        },
        // 我的地址列表
        get_my_address() {
            this.api.get_address().then(res => {
                this.address_list = res.data;
                this.address_list_index = 0;
            });
        },

        // 切换选中的地址
        chang_address_list(e) {
            this.address_list_index = e;
        },

        // 获取地址资源
        get_all_available() {
            this.api.get_all_available().then(res => {
                this.all_available = res.data;
            });
        },

        // 切换地址
        sheng_Change(e) {
            this.obj.province = e;
            this.all_available.forEach(element => {
                if (element.name === e) {
                    this.all_shi = element.children;
                }
            });
        },
        shi_Change(e) {
            this.obj.city = e;
            this.all_shi.forEach(element => {
                if (element.name === e) {
                    this.all_qu = element.children;
                    if (element.name === '成都市') {
                        this.obj.ring = '';
                        this.sanhuan_show = true;
                    } else {
                        this.sanhuan_show = false;
                        delete this.obj['ring'];
                    }
                }
            });
        },
        qu_Change(e) {
            this.obj.area = e;
            this.all_qu.forEach(element => {
                if (element.name === e) {
                    this.obj.areaId = element.id;
                    this.all_qu2 = element.children;
                }
            });
        }
    },
    created() {
        // 请求我的可用证书
        const data = JSON.parse(localStorage.cart_goods_list);
        this.cart_goods_list = data;
        this.goods_all_count = this.cart_goods_list[0].quantity;
        console.log(this.cart_goods_list);
        this.get_my_address();
        this.get_all_available();
        this.get_pointMy();
        this.get_cart_cuxiao();

        if (data[0] && data[0].active_list) {
            const sku = data[0].active_list[0].skuList;
            let usingPointMax = 0;
            sku.quantity = data[0].quantity;
            // 显示的小计总价           单价     *    数量
            sku.price_total = sku.price * sku.quantity;
            // 如果是vip他的价格就是下面的
            if (sku.currentUserVipPrice) {
                // vip单品总价             *  单品数量
                const total = sku.currentUserVipPrice.price * sku.quantity;
                // 显示的小计总价
                sku.price_discount = sku.price_total - total;
                sku.price_total = total;
            }
            usingPointMax = sku.price_total;
            this.usingPointMax = usingPointMax;
            this.sku = sku;
            this._zongjia = this.zongjia = sku.price_total;
            this.get_pointRuleConfig();
        }
    }
};
</script>

<style scoped>
.biaotou {
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    background: #f4f4f4;
}
/deep/.ant-form-item {
    margin-bottom: 0px;
}
.tiao:hover {
    cursor: pointer;
}
.sub_but {
    width: 140px;
    height: 40px;
    background: #f24145;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: right;
    margin-top: 4%;
    overflow: hidden;
    cursor: pointer;
}

.details_address {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 28px;
    float: right;
    margin-top: 1%;
    margin-right: 4%;
}

.actual_price_num {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #f24145;
    line-height: 28px;
    float: right;
    margin-right: 4%;
    margin-top: 1%;
}

.actual_price {
    font-size: 18px;
    margin-top: 1%;
    margin-right: 4%;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    float: right;
}

.price_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
}

.jifen_txt2 {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
    float: right;
    cursor: pointer;
}

.jifen_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: right;
    margin-right: 2%;
    margin-top: 1%;
}

.order_beizhu {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-top: 1%;
    margin-left: 2%;
    float: left;
}

.goods_list_item {
    width: 10%;
    height: 100%;
    float: left;
    text-align: center;
    line-height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.bianju {
    margin-top: 12px;
}

.zhidu {
    width: 80px;
    height: 30px;
    line-height: 28px;
    border: 1px solid #2b9a34;
    outline: none;
}

.zhidu:hover {
    cursor: pointer;
}

.goods_list {
    width: 100%;
    height: 40px;
    background: #e8e6e6;
    margin-top: 2%;
}

.catr_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    float: right;
}

.shop_name {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 2%;
}

.ziying {
    width: 32px;
    height: 20px;
    background: #2b9a34;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    float: left;
    margin-left: 4%;
}

.submit_but {
    width: 140px;
    height: 40px;
    background: #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    float: left;
    color: #ffffff;
    cursor: pointer;
}

.add_address_form {
    width: 10%;
    text-align: right;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 42px;
    float: left;
}

.add_address_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-top: 2%;
}

.address_item_4 {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666;
    float: right;
    line-height: 32px;
}

.address_item_3 {
    width: 60px;
    height: 18px;
    background: #f24145;
    text-align: center;
    line-height: 18px;
    color: #fff;
    float: left;
    font-size: 12px;
    margin-left: 4%;
    margin-top: 1%;
}

.address_item_2 {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
    margin-left: 4%;
    text-align: center;
    line-height: 32px;
}

.address_item_1 {
    width: 140px;
    height: 32px;
    border: 1px solid #ede9e9;
    text-align: center;
    line-height: 32px;
    float: left;
}

.address_item {
    width: 100%;
    height: 32px;
    /* background: #F4F4F4; */
    margin-top: 2%;
    cursor: pointer;
}

.receiving_info_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-left: 1%;
}

.receiving_info_bor {
    width: 3px;
    height: 23px;
    border: 3px solid #2b9a34;
    float: left;
}

.place_order_root {
    width: 100%;
    border: 1px solid #ede9e9;
    padding: 2%;
}

.place_order_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    padding: 2% 0;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/direct_place_order.vue